<div class="h-screen overflow-hidden">
  @if (isLoadingUserContext()) {
    <div class="h-full flex items-center justify-center">
      <div class="text-center">
        <div
          class="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"
        ></div>
        <p class="mt-4 text-gray-600">Loading...</p>
      </div>
    </div>
  } @else if (userContextError()) {
    <vtnz-error-loading-system
      [errorMessage]="userContextError()"
      [title]="'Error Loading System Data'"
      (retry)="retryLoadUserContext()"
    />
  } @else {
    <vtnz-sidebar
      [topNavItems]="topNavItems()"
      [bottomNavItems]="bottomNavItems()"
      [user]="currentUserContext()"
      [accounts]="accounts()"
      [selectedAccount]="selectedCustomerAccount()"
      [applicationTitle]="resolvedApplicationTitle()"
      [displayBottomMenu]="true"
      (accountSelected)="onAccountSelected($event)"
    />
    <div
      class="h-full flex flex-col transition-all duration-300 ease-in-out"
      [ngClass]="{
        'xl:ml-[230px]': sidebarService.isExpanded() || sidebarService.isHovered(),
        'xl:ml-[52px]': !sidebarService.isExpanded() && !sidebarService.isHovered(),
        'ml-0': sidebarService.isMobile(),
      }"
    >
      <!-- app header start -->
      <vtnz-header
        [applicationTitle]="resolvedApplicationTitle()"
        [user]="currentUserContext()"
        [displayHelp]="true"
        (helpClicked)="toggleSupportModal()"
      />
      <!-- app header end -->
      <main class="flex-1 overflow-y-auto overflow-x-hidden p-4 md:p-6">
        <div class="mx-auto w-full max-w-(--breakpoint-2xl)">
          <router-outlet></router-outlet>
        </div>
      </main>
    </div>

    <!-- Support Modal -->
    <vtnz-support-modal
      [isOpen]="isSupportModalOpen()"
      [position]="'top-right'"
      [headerBackground]="'orange'"
      (closeModal)="closeSupportModal()"
    />
  }
</div>
